// Shared allowlist for read-only mode safe paths.
// Keep this file environment-agnostic (no browser/global references).

import paths from './maintenancePaths.json';

export const READ_ONLY_SAFE_PREFIXES = paths.readOnlySafePrefixes || [];

export const READ_ONLY_SAFE_REGEX = [];

export function isReadOnlySafePath(pathname = '') {
  if (!pathname) return false;
  const path = String(pathname).toLowerCase();
  if (READ_ONLY_SAFE_PREFIXES.some((p) => path.startsWith(p.toLowerCase()))) return true;
  return READ_ONLY_SAFE_REGEX.some((re) => re.test(path));
}
